export default [
  {
    path: '/admin/options/phone/statuses',
    name: 'adminOptionPhonesStatuses',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/admin/options/phone/statuses.vue'),
  },
  {
    path: '/admin/options/phone/types',
    name: 'adminOptionPhoneTypes',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/admin/options/phone/types.vue'),
  },
  {
    path: '/admin/options/address/statuses',
    name: 'adminOptionAddressStatuses',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/admin/options/address/statuses.vue'),
  },
  {
    path: '/admin/options/address/types',
    name: 'adminOptionAddressTypes',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/admin/options/address/types.vue'),
  },
  {
    path: '/admin/options/call/statuses',
    name: 'adminOptionCallStatuses',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/admin/options/call/statuses.vue'),
  },
  {
    path: '/admin/options/call/types',
    name: 'adminOptionCallTypes',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/admin/options/call/types.vue'),
  },
  {
    path: '/admin/options/contactface/types',
    name: 'adminOptionContactfaceTypes',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/admin/options/contactface/types.vue'),
  },
  {
    path: '/admin/options/departure/statuses',
    name: 'adminOptionDepartureStatuses',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/admin/options/departure/statuses.vue'),
  },
  {
    path: '/admin/options/debt/statuses',
    name: 'adminOptionDebtStatuses',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/admin/options/debt/statuses.vue'),
  },
];
